




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid from '@/components/DataGrid.vue'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as links from "@/data/sources/complianceLinks"
import {executeQuery} from "@/data/repos/query";

@Component({
  components: {
    DataGrid,
  },
})
export default class CarterClinicalDrillDown extends Vue {
  @Prop() public args!: { locationId: number, userId: number }
  public fields = [
    {name: 'RegionName', title: 'Region', dataType: 'Text', sort: 1, component: DataGridLink, callback: links.region},
    {name: 'SiteName', title: 'Site', dataType: 'Text', sort: 1, component: DataGridLink, callback: links.site},
    {name: 'BuildingName', title: 'Building', dataType: 'Text', sort: 1, component: DataGridLink, callback: links.building},
    {name: 'BuildingArea', title: 'Building Area', dataType: 'Number', sort: 1},
    {name: 'ClinicalArea', title: 'Clinical Area', dataType: 'Number', sort: 1},
    {name: 'PercClinical', title: 'Clinical %', dataType: 'Number', sort: 1, suffix: '%'},
    {name: 'Status', title: 'Status', dataType: 'Text', sort: 1},
  ]

  public async getData(offset: number = 0, limit: number = 250) {
    return await executeQuery("idr", "carterClinicalPercentageBreakdown",
      {locationId: this.args.locationId},
      this.filterBreakdown,
      offset, limit)
  }

  private filterBreakdown(data: any[]): any {
    const filteredData: any[] = []
    for (const item of data) {
      // [{
      // "id":15618800,
      // "RegionName":"LLR - University Hospitals Leicester123",
      // "SiteName":"Glenfield Hospital",
      // "name":"!Adam",
      // "PercClinical":0.0000,
      // "ClinicalArea":0.0000,
      // "BuildingArea":0.0000,
      // "Status":"Fail"
      // },...]
      // if (parseInt(item.BuildingArea, 10) === 0) {
      //   item.OccupiedPercentage = 0
      // } else {
      //   item.OccupiedPercentage = Math.round(item.OccupiedArea / item.BuildingArea * 100)
      // }
      filteredData.push({
        RegionName: item.RegionName,
        SiteName: item.SiteName,
        BuildingId: item.id,
        BuildingName: item.name,
        PercClinical: item.PercClinical,
        ClinicalArea: item.ClinicalArea,
        BuildingArea: item.BuildingArea,
        Status: item.Status,
      })
    }
    return filteredData
  }
}
